import { Stack, Typography } from '@mui/material';
import { useAppTFunction } from '@retail/app/i18n';
import { usePermissionsForCurrentUser } from '@retail/app/stores/selected-context';
import { ExportButtons } from '@retail/export/components';
import { useMultateRecalculateTotalFile } from '@retail/export/data-access';
import { useToast } from '@retail/hooks';
import { TagHeading } from '@shared/components';

interface Props {
  assortmentId: number;
  handleUpdateDateTimePicker: (fromDate: Date | null) => void;
  toggleExportDialog: () => void;
  isLoadingDownload: boolean;
  disableDownload: boolean;
}

export function ExportToolbar({
  assortmentId,
  handleUpdateDateTimePicker,
  toggleExportDialog,
  isLoadingDownload,
  disableDownload,
}: Props) {
  const t = useAppTFunction();
  const toast = useToast();

  const { userCanCreate, userCanUpdate } = usePermissionsForCurrentUser();
  const canDownloadTotalFile = userCanCreate('ITEM_EXPORT');
  const canRecalculateTotalFile = userCanUpdate('ITEM_EXPORT');

  const { mutateAsync: recalculateTotalFile, isPending: isLoadingRecalculate } =
    useMultateRecalculateTotalFile({ assortmentId });

  const handleRecalculate = () => {
    recalculateTotalFile({})
      .then(() => {
        toast.success(t('export.messages.recalculationComplete'));
      })
      .catch(() => {
        console.error();
        toast.error(t('export.errors.recalculationFailed'));
      });
  };
  return (
    <Stack flexDirection="row" justifyContent="space-between" whiteSpace="nowrap" pt={3} px={2}>
      <TagHeading>
        <Typography variant="h4">{t('app.routes.export')}</Typography>
      </TagHeading>
      <ExportButtons
        onUpdateDateTimePicker={handleUpdateDateTimePicker}
        toggleExportDialog={canDownloadTotalFile ? toggleExportDialog : undefined}
        handleRecalculate={canRecalculateTotalFile ? handleRecalculate : undefined}
        isLoadingRecalculate={isLoadingRecalculate}
        isLoadingDownload={isLoadingDownload}
        noSelectedSupplierIds={disableDownload}
      />
    </Stack>
  );
}
